import request from './request'
import * as http from '@/libs/http'

/**
 * 店舗の車両情報を取得する
 *
 * @param {Number} shopid 店舗ID
 * @param {Number} carid 車両ID
 * @param {Array} fields 追加フィールド
 * @returns {Response} レスポンスデータ
 */
export function getShopCar (shopid, carid, fields = []) {
  return request.get(`/shops/${shopid}/cars/${carid}`, {
    params: {
      fields: [
        'id',
        ...fields
      ]
    },
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
